<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 21 21"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.7833 12.1938C14.4893 12.4568 14.3773 12.8679 14.4973 13.2435L16.5771 19.7542L11.0687 15.9461C10.7265 15.7096 10.2735 15.7096 9.93135 15.9461L4.42286 19.7542L6.50266 13.2435C6.62266 12.8679 6.51068 12.4568 6.21674 12.1938L1.30904 7.80435H7.52438C7.94529 7.80435 8.32114 7.54079 8.46455 7.14507L10.5181 1.47843L12.5356 7.14002C12.6776 7.53836 13.0548 7.80435 13.4776 7.80435L19.691 7.80435L14.7833 12.1938Z" :fill="filled ? color : emptyColor" :stroke="color"/>
  </svg>

</template>

<script>
export default {
  name: 'Star',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    filled: {
      type: Boolean,
      required: false,
      default: false
    },
    color: {
      type: String,
      required: false,
      default: '#000'
    },
    emptyColor: {
      type: String,
      required: false,
      default: '#FFF'
    }
  },
};

</script>
